<template>
  <div class="widget digital-presence title-margin">
    <h3 class="widget-title">
      Top 10 Campañas en {{ $route.params.productName }}
    </h3>
    <div class="content">
      <h4 class="card-title">Resultados en {{ $route.params.productName }}</h4>
      <div class="results">
        <table class="table">
          <thead>
            <tr>
              <th v-if="true" scope="col">Campaña</th>
              <th v-if="true" scope="col">Impresiones</th>
              <th v-if="true" scope="col">Clicks</th>
              <th v-if="true" scope="col">CTR</th>
              <th v-if="true" scope="col">Conversiones</th>
              <th v-if="true" scope="col">Alcance</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(campaing, index) in campaigns" :key="index">
              <!-- text wrapping -->
              <td v-if="true" scope="row">
                <div class="text-wrapper">
                  <p class="text-truncate">
                    {{ campaing.metrics.campaign_name }}
                  </p>
                </div>
              </td>
              <td v-if="true" scope="row">
                {{ parseInt(campaing.metrics.impressions).toLocaleString() }}
              </td>
              <td v-if="true" scope="row">
                {{ parseInt(campaing.metrics.clicks).toLocaleString() }}
              </td>
              <td v-if="true" scope="row">{{ campaing.metrics.ctr }}%</td>
              <td v-if="true" scope="row">
                {{ parseInt(campaing.metrics.conversion).toLocaleString() }}
              </td>
              <td v-if="true" scope="row">
                {{ parseInt(campaing.metrics.reach).toLocaleString() }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tiktok-campaings",
  props: {
    campaigns: Array
  }
  // data: () => ({
  //   campaings: [{ title: "title" }]
  // })
};
</script>

<style lang="scss" scoped>
.card-title{
  width: 75%;
  margin: 10px auto;

}
.table {
  margin: 0px auto;
  width: 75%; 
}
.text-wrapper {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-truncate:hover {
  overflow: visible;
  white-space: normal;
  text-overflow: clip;
  transition: all 0.3s ease;
}
.text-truncate:hover p {
  overflow: visible;
  white-space: normal;
  text-overflow: clip;
  transition: all 0.3s ease;
}
.text-truncate:hover p {
  max-width: 100%;
  transition: all 0.3s ease;
}
.content {
  border-radius: 5px;
  margin: 0px;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
}

// @include respond-above(sm) {
//   .content {
//     // width: 75%;
//     border-radius: 5px;
//     margin: 0px;
//     padding: 20px;
//     background-color: #fff;
//     border-radius: 8px;
//   }
// }
</style>
